
import { createSlice } from '@reduxjs/toolkit';

const locationSlice = createSlice({
  name: 'location',
  initialState: {
    latitude: 0,
    longitude: 0
  },
  reducers: {}
});

export default locationSlice.reducer;